import {combineReducers} from 'redux';
import reports from './reports/reducers';
import apidocument from './apidocument/reducer';
import configuration from './configuration/reducer';

export default combineReducers({
  reports,
  apidocument,
  configuration,
});
